import { RouteObject, createBrowserRouter } from "react-router-dom";
// pages
import Login from "../page/login/Login";
import ForgotPassword from "../page/login/ForgotPassword";
import ResetPassword from "../page/login/ResetPassword";
import Home from "../page/home/Home";
import SearchUser from "../page/user/SearchUser";
import User from "../page/user/User";
import Clubs from "../page/clubs/Clubs";
import Club from "../page/clubs/Club";
import PrivateRoute from "../components/private-route/PrivateRoute";
import Admins from "../page/admins/Admins";
import CreateClub from "../page/clubs/CreateClub";
import EditClub from "../page/clubs/EditClub";
import Keywords from "../page/keywords/Keywords";
import Requests from "../page/requests/Requests";
import RegRequests from "../page/reg-requests/RegRequests";
import CompaniesList from "../page/user/CompaniesList";
import { ADMIN_ROLE } from "../constants";
import Library from "../page/library/Library";

// Matrix pages (primary)
import CreateChatMatrix from "../page/clubs/CreateChatMatrix";
import ClubChatMatrix from "../page/clubs/ClubChatMatrix";
import EditChatMatrix from "../page/clubs/EditChatMatrix";
import ClubChatMembers from "../page/clubs/ClubChatMembers";

const routes: RouteObject[] = [
	{
		path: "/login",
		element: <Login />,
	},
	{
		path: "/forgot-password",
		element: <ForgotPassword />,
	},
	{
		path: "/reset-password",
		element: <ResetPassword />,
	},
	{
		path: "/",
		element: <PrivateRoute />,
		children: [
			{
				path: "/",
				element: <Home />,
				children: [
					{
						index: true,
						path: "/home",
						element: <SearchUser />,
					},
					{
						path: "/search-user",
						element: <SearchUser />,
						handle: {
							accessRoles: [ADMIN_ROLE.CLUB_ADMIN, ADMIN_ROLE.CLUB_MODERATOR],
						},
					},
					{
						path: "/user/:userId",
						element: <User />,
					},
					{
						path: "/clubs",
						element: <Clubs />,
						handle: {
							accessRoles: [ADMIN_ROLE.ADMIN],
						},
					},
					{
						path: "/club/create",
						element: <CreateClub />,
						handle: {
							accessRoles: [ADMIN_ROLE.ADMIN],
						},
					},
					{
						path: "/club",
						element: <Club />,
					},
					{
						path: "/club/:clubId",
						element: <Club />,
						handle: {
							accessRoles: [ADMIN_ROLE.ADMIN, ADMIN_ROLE.CLUB_ADMIN, ADMIN_ROLE.CLUB_MODERATOR],
						},
					},
					{
						path: "/club/:clubId/edit",
						element: <EditClub />,
						handle: {
							accessRoles: [ADMIN_ROLE.ADMIN, ADMIN_ROLE.CLUB_ADMIN],
						},
					},
					// ── PRIMARY routes → Matrix ──
					{
						path: "/club/:clubId/chat/create",
						element: <CreateChatMatrix />,
						handle: {
							accessRoles: [ADMIN_ROLE.CLUB_ADMIN, ADMIN_ROLE.CLUB_MODERATOR],
						},
					},
					{
						path: "/club/:clubId/chat/edit/:chatId",
						element: <EditChatMatrix />,
						handle: {
							accessRoles: [ADMIN_ROLE.CLUB_ADMIN, ADMIN_ROLE.CLUB_MODERATOR],
						},
					},
					{
						path: "/club/:clubId/chat/:chatId/members",
						element: <ClubChatMembers />,
						handle: {
							accessRoles: [ADMIN_ROLE.CLUB_ADMIN, ADMIN_ROLE.CLUB_MODERATOR],
						},
					},
					{
						path: "/club/:clubId/chat/:chatId",
						element: <ClubChatMatrix />,
						handle: {
							accessRoles: [ADMIN_ROLE.CLUB_ADMIN, ADMIN_ROLE.CLUB_MODERATOR],
						},
					},
					// ── Matrix explicit routes (aliases) ──
					{
						path: "/club/:clubId/matrix/chat/create",
						element: <CreateChatMatrix />,
						handle: {
							accessRoles: [ADMIN_ROLE.CLUB_ADMIN, ADMIN_ROLE.CLUB_MODERATOR],
						},
					},
					{
						path: "/club/:clubId/matrix/chat/edit/:chatId",
						element: <EditChatMatrix />,
						handle: {
							accessRoles: [ADMIN_ROLE.CLUB_ADMIN, ADMIN_ROLE.CLUB_MODERATOR],
						},
					},
					{
						path: "/club/:clubId/matrix/chat/:chatId",
						element: <ClubChatMatrix />,
						handle: {
							accessRoles: [ADMIN_ROLE.CLUB_ADMIN, ADMIN_ROLE.CLUB_MODERATOR],
						},
					},
					{
						path: "/admins",
						element: <Admins />,
						handle: {
							accessRoles: [ADMIN_ROLE.ADMIN, ADMIN_ROLE.CLUB_ADMIN],
						},
					},
					{
						path: "/keywords",
						element: <Keywords />,
						handle: {
							accessRoles: [ADMIN_ROLE.CLUB_ADMIN, ADMIN_ROLE.CLUB_MODERATOR],
						},
					},
					{
						path: "/requests",
						element: <Requests />,
						handle: {
							accessRoles: [ADMIN_ROLE.CLUB_ADMIN, ADMIN_ROLE.CLUB_MODERATOR],
						},
					},
					{
						path: "/registration-requests",
						element: <RegRequests />,
						handle: {
							accessRoles: [ADMIN_ROLE.CLUB_ADMIN, ADMIN_ROLE.CLUB_MODERATOR],
						},
					},
					{
						path: "/companies",
						element: <CompaniesList />,
						handle: {
							accessRoles: [ADMIN_ROLE.CLUB_ADMIN, ADMIN_ROLE.CLUB_MODERATOR],
						},
					},
					{
						path: "/library",
						element: <Library />,
						handle: {
							accessRoles: [ADMIN_ROLE.CLUB_ADMIN, ADMIN_ROLE.CLUB_MODERATOR],
						},
					},
				],
			},
		],
	},
];

const router = createBrowserRouter(routes);

export default router;
